import React, { useState, useEffect } from "react";
import axios from "axios";
import { Container, Row, Col, Carousel, Card } from "react-bootstrap";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";

const BannersAndPromotions = () => {
  const [banners, setBanners] = useState([]); // State for banner data
  const [loading, setLoading] = useState(true); // State for loading status

  // Fetch banners from the API
  const fetchBanners = async () => {
    try {
      const response = await axios.get("https://agpipefitting.org.et/api/banners");
      console.log("API Response:", response.data); // Debugging log
      if (response.data.status === "success" && Array.isArray(response.data.data)) {
        setBanners(response.data.data);
      } else {
        console.error("Failed to fetch banners:", response.data.message || "Unknown error");
      }
    } catch (error) {
      console.error("Error fetching banners:", error.message);
    } finally {
      setLoading(false);
    }
  };

  // Fetch banners on component load
  useEffect(() => {
    fetchBanners();
  }, []);

  // Common styles for the cards
  const cardStyles = {
    backgroundSize: "cover",
    width: "800px",
    height: "300px",
    backgroundPosition: "center",
    transition: "transform 0.3s ease",
  };

  const buttonStyles = {
    background: "linear-gradient(90deg, rgb(222, 89, 27), rgb(101, 170, 244))",
    color: "#fff",
    border: "none",
    outline: "none",
    fontSize: "1.2rem",
    fontWeight: "600",
    letterSpacing: "0.5px",
    cursor: "pointer",
    transition: "all 0.3s ease-in-out",
  };

  return (
    <section id="banners" className="py-5">
      <h3 className="text-center mb-4 font-weight-bold text-dark display-4">
       Promotional Banners
      </h3>
      <Container>
        {loading ? (
          <div className="text-center py-5">
            <span className="spinner-border text-primary" role="status"></span>
            <p className="mt-3">Loading banners...</p>
          </div>
        ) : banners.length === 0 ? (
          <div className="text-center py-5">
            <p>No banners available. Please check back later.</p>
          </div>
        ) : (
          <Carousel fade interval={3000} indicators={false}>
            {banners.map((banner) => (
              <Carousel.Item key={banner.id}>
                <Row className="d-flex justify-content-center">
                  <Col md={6} sm={8} xs={12} className="mb-4">
                  <Card
  className="promo-card shadow-lg border-0 rounded"
  style={{
    ...cardStyles,
    backgroundImage: `url(${banner.image_url})`,
  }}
>

                      <div className="d-flex justify-content-center align-items-center">
                        <div className="text-center p-4 p-md-5 rounded shadow-lg">
                          <Card.Title
                            className="text-white fw-bold display-3 mb-3"
                            style={{ fontSize: "2rem" }}
                          >
                            {banner.title}
                          </Card.Title>
                          <Card.Text
                            className="text-white mb-4 fs-4"
                            style={{ fontSize: "1.5rem" }}
                          >
                            {banner.description}
                          </Card.Text>
                          <Link to="/products" style={{ textDecoration: "none" }}>
                            <motion.button
                              className="px-5 py-3 rounded-pill shadow"
                              style={buttonStyles}
                              whileHover={{
                                background:
                                  "linear-gradient(90deg, rgb(255, 107, 28), rgb(21, 126, 0))",
                                color: "#fff",
                                boxShadow: "0px 10px 20px rgba(0, 0, 0, 0.3)",
                              }}
                              whileTap={{ scale: 0.95 }}
                            >
                              Shop Now
                            </motion.button>
                          </Link>
                        </div>
                      </div>
                    </Card>
                  </Col>
                </Row>
              </Carousel.Item>
            ))}
          </Carousel>
        )}
      </Container>
    </section>
  );
};

export default BannersAndPromotions;
